import { currentBrand } from '../lib/brand.js';
import { TnMark, TnWordmark } from './TnMark.js';

/** Compact mark for set-password and reset cards. */
export function BrandMark({ size = 'sm' }: { size?: 'sm' | 'lg' }): JSX.Element {
  const brand = currentBrand();
  if (brand.id === 'takenotes') return <TnMark size={size} />;
  return (
    <img
      className={size === 'lg' ? 'tn-mark tn-mark--lg' : 'tn-mark'}
      src={brand.markSrc}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}

/**
 * Header and login lockup.
 * TakeNotes: locked PNG via TnWordmark.
 * AgentMeetings: George's handwritten header PNG when headerLockupSrc is set,
 * otherwise the mark plus an Inter wordmark.
 */
export function BrandWordmark(
  { className, size = 'lg' }: { className?: string; size?: 'header' | 'lg' } = {},
): JSX.Element {
  const brand = currentBrand();
  if (brand.id === 'takenotes') return <TnWordmark size={size} className={className} />;
  if (brand.headerLockupSrc) {
    const cls = ['tn-lockup', `tn-lockup--${size}`, className].filter(Boolean).join(' ');
    return <img className={cls} src={brand.headerLockupSrc} alt={brand.name} draggable={false} />;
  }
  const cls = ['am-lockup', `am-lockup--${size}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls}>
      <img className="am-lockup__mark" src={brand.markSrc} alt="" aria-hidden="true" draggable={false} />
      <span className="am-lockup__word">
        <span className="am-lockup__ink">Agent</span>
        <span className="am-lockup__accent">Meetings</span>
      </span>
    </span>
  );
}
